import { hot } from "react-hot-loader";

import App from "./components/App";

export default hot(module)(App);
